@if (operation) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.${operation.type}` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile [title]="'WORKFLOWS.FORM.OPERATIONS.POL_MODE' | translate">
        <span>{{ 'WORKFLOWS.DETAIL.POL_DESCRIPTION' | translate }}</span>

        <tec-info-group [label]="'WORKFLOWS.DETAIL.CAPTURE_METHOD' | translate">
            @if (operation?.config?.mode === 'auto') {
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_POL_MODE.ACTIVE' | translate }}</span>
            } @else if (operation?.config?.mode === 'manual') {
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.MODAL_POL_MODE.STATIC' | translate }}</span>
            }
        </tec-info-group>

        @if (operation?.config?.mode === 'auto') {
        <tec-divider />

        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.DEMAND_LEVEL' | translate | uppercase }}</span>

            <div class="grid grid-i3">
                <tec-info-group [label]="'WORKFLOWS.DETAIL.LEVEL' | translate">
                    <span>{{ demandLevelLabel | translate }}</span>
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TESTS' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TESTS_TOOLTIP' | translate"
                >
                    <tec-badge [label]="operation?.config?.setting?.total_test" type="square" />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.NUM_TRIED_TOOLTIP' | translate"
                >
                    <tec-badge [label]="operation?.config?.setting?.total_tries" type="square" />
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_TOOLTIP' | translate"
                >
                    <span
                        >{{ `WORKFLOWS.FORM.OPERATIONS.ORDER_TESTS_OPTIONS.${operation?.config?.setting?.type?.toUpperCase()}` | translate }}</span
                    >
                </tec-info-group>
                <tec-info-group
                    [label]="'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD' | translate"
                    [tooltip]="'WORKFLOWS.FORM.OPERATIONS.CONFIDENCE_THRESHOLD_TOOLTIP' | translate"
                >
                    @if (isCustomConfidenceThreshold()) {
                    <span>{{ getConfidenceThresholdLabelKey() | translate }}</span>
                    } @else {
                    <tec-rate-status
                        [label]="getConfidenceThresholdLabelKey() | translate"
                        [value]="workflowsHelper.getScoring(operation?.config?.setting) === CONFIDENCE_THRESHOLD.MAX ? 5 : 4"
                    />
                    }
                </tec-info-group>
                @if (isCustomConfidenceThreshold()) {
                <tec-info-group [label]="'WORKFLOWS.FORM.OPERATIONS.CUSTOM_CONFIDENCE_THRESHOLD' | translate">
                    <tec-badge [label]="getCustomConfidenceThresholdDisplay()" type="square" />
                </tec-info-group>
                }
            </div>
        </div>

        <tec-divider />

        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS' | translate | uppercase }}</span>

            <div class="grid grid-e4">
                <tec-card-select
                    [disabled]="true"
                    [selected]="true"
                    [img]="'images/centrado.png'"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.CENTER' | translate"
                />
                <tec-card-select
                    [disabled]="true"
                    [selected]="operation?.config?.setting?.available_tests?.includes(POL_TEST.SMILE)"
                    [img]="'images/smile.png'"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.SMILE' | translate"
                />
                <tec-card-select
                    [disabled]="true"
                    [selected]="operation?.config?.setting?.available_tests?.includes(POL_TEST.TURN_RIGHT_HEAD)"
                    [img]="'images/turn-right-head.png'"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.TURN_RIGHT_HEAD' | translate"
                />
                <tec-card-select
                    [disabled]="true"
                    [selected]="operation?.config?.setting?.available_tests?.includes(POL_TEST.TURN_LEFT_HEAD)"
                    [img]="'images/turn-left-head.png'"
                    [title]="'WORKFLOWS.FORM.OPERATIONS.AVAILABLE_TESTS_OPTIONS.TURN_LEFT_HEAD' | translate"
                />
            </div>
        </div>

        <tec-divider />

        <div class="item-group">
            <span>{{ 'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate | uppercase }}</span>

            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FALLBACK_DESCRIPTION' | translate"
            >
                <span
                    >{{ `WORKFLOWS.FORM.OPERATIONS.${(operation?.config?.fallback?.type === 'manual') ? 'FALLBACK_FINISH' : 'FALLBACK_STATIC'}` | translate }}</span
                >
            </tec-info-group>
        </div>
        }
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.GENERAL.ANTIFRAUDE_GENERAL' | translate">
        <div class="grid grid-i2">
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.FACIAL_RECOGNITION' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FACIAL_RECOGNITION_DESCRIPTION' | translate"
            >
                <tec-tag
                    [label]="`WORKFLOWS.DETAIL.${operation?.config?.fraud_scoring?.facial_recognition ? 'ACTIVE' : 'INACTIVE'}` | translate"
                    [status]="operation?.config?.fraud_scoring?.facial_recognition ? 'success' : 'disabled'"
                />
            </tec-info-group>
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.FACE_MATCH' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.FACE_MATCH_DESCRIPTION' | translate"
            >
                <tec-tag
                    [label]="`WORKFLOWS.DETAIL.${operation?.config?.fraud_scoring?.face_match ? 'ACTIVE' : 'INACTIVE'}` | translate"
                    [status]="operation?.config?.fraud_scoring?.face_match ? 'success' : 'disabled'"
                />
            </tec-info-group>
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.PERCENTAGE_SIMILARITY' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.PERCENTAGE_SIMILARITY_DESCRIPTION' | translate"
            >
                <span>{{ operation.config?.fraud_scoring?.percentage_similarity ?? 0 }}%</span>
            </tec-info-group>
            <tec-info-group
                [label]="'WORKFLOWS.FORM.OPERATIONS.ANTISPOOFING' | translate"
                [tooltip]="'WORKFLOWS.FORM.OPERATIONS.ANTISPOOFING_DESCRIPTION' | translate"
            >
                <tec-tag
                    [label]="`WORKFLOWS.DETAIL.${operation?.config?.fraud_scoring?.anti_spoofing ? 'ACTIVE' : 'INACTIVE'}` | translate"
                    [status]="operation?.config?.fraud_scoring?.anti_spoofing ? 'success' : 'disabled'"
                />
            </tec-info-group>
        </div>
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.TUTORIAL_DESCRIPTION' | translate"
        >
            <tec-tag
                [label]="`WORKFLOWS.DETAIL.${operation?.config?.tutorial ? 'ACTIVE' : 'INACTIVE'}` | translate"
                [status]="operation?.config?.tutorial ? 'success' : 'disabled'"
            />
        </tec-info-group>
    </tec-tile>
</tec-collapse>
}
